import https, { getApiConfig } from '../utils/request'
import { RequestParams, ContentType, Method } from 'axios-mapper'

export const loginRequest = (userInfo: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.migrateUrl).request('ke/v1/user/login', Method.POST, userInfo, ContentType.json)
}

export const userMenuList = () => {
    return https().request('menuList', Method.GET, {}, ContentType.json)
}

export const userInfoList = () => {
    return https().request('usersList', Method.GET, {}, ContentType.json)
}

export const goodList = (page?: number, size?: number) => {
    return https('https://api.kilimall.com/').request(`ke/v1/product/recommend?size=${ size ? size : 20 }&page=${ page ? page : 1 }&total=500&type=1`, Method.GET, {}, ContentType.json)
}

export const captcha = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.migrateUrl).request(`${api_config.siteCode}/v1/user/captcha`, Method.POST, data, ContentType.form)
}

export const checkCaptchas = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.migrateUrl).request(`${api_config.siteCode}/v1/user/checkCaptcha`, Method.POST, data, ContentType.form)
}

export const findPassword = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.migrateUrl).request(`/v1/${api_config.siteCode}/buyer/find_password`, Method.POST, data, ContentType.form)
}

export const storeInfo = () => {
    const api_config = getApiConfig()
    return https(api_config.migrateUrl).request(`/apistore/v1/ke/seller/store/info`, Method.GET)
}

/**
 * 
 * @returns 保存json到S3
 */
export const postJsonFile = (data: RequestParams) => {
    const api_config = getApiConfig()
    return https(api_config.migrateUrl).request(`/v1/ke/json`, Method.POST, data, ContentType.json)
}


